import classnames from 'classnames';
import React from 'react';

import { IconList16 } from '@cineamo/ui/src/icons/ic-list';
import { IconMap16 } from '@cineamo/ui/src/icons/ic-map';

import { useAnalytics } from '../providers/analyticsProvider';

const ViewTypeSelector: React.FC<{
    viewType: 'list' | 'map';
    setViewType: (viewType: 'list' | 'map') => void;
    className: string;
    selectedItemClassName: string;
    notSelectedItemClassName: string;
}> = ({ viewType, setViewType, className, selectedItemClassName, notSelectedItemClassName }) => {
    const { track } = useAnalytics();
    return (
        <div className={classnames('flex flex-row justify-end flex-shrink-0', className)}>
            <button
                className={classnames(
                    'px-16 py-8',
                    viewType === 'list' ? selectedItemClassName : notSelectedItemClassName
                )}
                onClick={() => {
                    setViewType('list');
                    track('Showtimes List View Type Selected', {
                        viewType: 'list'
                    });
                }}>
                <IconList16 />
            </button>
            <button
                className={classnames(
                    'px-16 py-8',
                    viewType === 'map' ? selectedItemClassName : notSelectedItemClassName
                )}
                onClick={() => {
                    setViewType('map');
                    track('Showtimes List View Type Selected', {
                        viewType: 'map'
                    });
                }}>
                <IconMap16 />
            </button>
        </div>
    );
};

export default ViewTypeSelector;
